(() => {
  if (customElements.get('cft-campaign')) return;
  class Campaign extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.tabs = [...this.querySelectorAll('[data-campaign-tab]')];
      this.panels = [...this.querySelectorAll('[data-campaign-panel]')];
      this.tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => this.select(index));
        tab.addEventListener('keydown', event => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let target = event.key === 'Home' ? 0 : this.tabs.length - 1;
          if (event.key.startsWith('Arrow')) target = (index + (event.key === 'ArrowRight' ? 1 : -1) + this.tabs.length) % this.tabs.length;
          this.select(target);
          this.tabs[target].focus();
        });
      });
      if (this.tabs.length) this.select(0);
      this.offer = this.querySelector('[data-campaign-offer]');
      if (!this.offer) return;
      this.updateClock();
      if (!this.offer.hidden) this.timer = setInterval(() => this.updateClock(), 1000);
      this.querySelector('[data-campaign-copy]').addEventListener('click', async event => {
        const code = this.querySelector('[data-campaign-code]');
        const button = event.currentTarget;
        if (code.hidden) {
          code.hidden = false;
          button.textContent = 'Copy code';
          button.setAttribute('aria-expanded', 'true');
          return;
        }
        const status = this.querySelector('[data-campaign-status]');
        try {
          await navigator.clipboard.writeText(code.textContent.trim());
          status.textContent = 'Code copied';
        } catch {
          status.textContent = 'Select the code to copy it.';
        }
      });
    }
    select(index) {
      this.tabs.forEach((tab, position) => {
        tab.setAttribute('aria-selected', String(position === index));
        tab.tabIndex = position === index ? 0 : -1;
      });
      this.panels.forEach((panel, position) => { panel.hidden = position !== index; });
    }
    updateClock() {
      const remaining = Date.parse(this.offer.dataset.endsAt) - Date.now();
      if (!Number.isFinite(remaining) || remaining <= 0) {
        this.offer.hidden = true;
        clearInterval(this.timer);
        return;
      }
      const seconds = Math.floor(remaining / 1000);
      const days = Math.floor(seconds / 86400);
      const hours = Math.floor(seconds / 3600) % 24;
      const minutes = Math.floor(seconds / 60) % 60;
      this.querySelector('[data-campaign-countdown]').textContent = `${days}d ${hours}h ${minutes}m ${seconds % 60}s`;
    }
    disconnectedCallback() { clearInterval(this.timer); }
  }
  customElements.define('cft-campaign', Campaign);
})();
